module.exports = __webpack_public_path__ + "img/clinics_and_services.234d1522.svg";